<app-bundles-list-component />